'use client';
import styles from '@/blocks/components/Controls/Pagination/styles.module.scss';
import { ArrowLeft, ArrowRight } from '@/blocks/components/Icons/Arrow';
import { UsePaginationItem } from '@mui/material/usePagination/usePagination';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

const PrevButtonContent = () => {
  const tr = useTranslations();
  return (
    <>
      <ArrowLeft />
      <span>{tr.rich('components.pagination.prev')}</span>
    </>
  );
};

const NextButtonContent = () => {
  const tr = useTranslations();
  return (
    <>
      <span>{tr.rich('components.pagination.next')}</span>
      <ArrowRight />
    </>
  );
};

export const PaginationPrevNextButton = (
  props: React.PropsWithChildren<{
    type: UsePaginationItem['type'];
    disabled?: boolean;
    onClick: (...args: any) => void;
  }>,
) => {
  return (
    <button
      className={classNames(styles.basePaginationItem, styles.paginationPrevNextButton)}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.type === 'previous' ? <PrevButtonContent /> : <NextButtonContent />}
    </button>
  );
};
